import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormArray, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

// utilities
import { forEach } from 'lodash';

// reactive
import { distinctUntilChanged, startWith, map, debounceTime } from 'rxjs/operators';

// services
import { QuestionService } from '../../services/question.service';

@Component({
    selector: 'percentage-allocation',
    templateUrl: './percentage-allocation.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: PercentageAllocationComponent,
        multi: true
    }],
    styles: []
})

export class PercentageAllocationComponent implements OnInit, ControlValueAccessor {
    @Input() form: FormGroup;
    sectionBlock: any;
    sectionInput: any;
    totalAllocation: any = 0;
    onChange: any = () => { };
    onTouched: any = () => { };
    arrayLength: number = 0;

    constructor(
        public route: ActivatedRoute,
        private questionService: QuestionService,
        private changeDetector: ChangeDetectorRef,
    ) {
        this.sectionBlock = route.snapshot.data.blockName;
    }

    ngOnInit() {
        // get inputs based on block
        this.sectionInput = { compound: 'AgentReportAgentInformation', field: 'AgentReportAgentInformationShare' };
        this.calculateAllocation();
    }

    get parentArray(): FormArray {
        return this.form.get(this.sectionInput.compound) as FormArray;
    }

    // Control Value Accessor interface
    writeValue(value: string) {
        this.totalAllocation = value;
        this.changeDetector.markForCheck();
    }

    // Control Value Accessor interface
    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    // Control Value Accessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    calculateAllocation(): void {
        // add subscription
        this.parentArray.valueChanges
            .pipe(
                startWith(this.parentArray),
                map((x) => {
                    return x.length;
                }),
                distinctUntilChanged(),
            ).subscribe((val) => {
            // inner subscription
            forEach(this.parentArray.controls, (control: any) => {
                // Total Allocation
                control.get(this.sectionInput.field).valueChanges
                    .pipe(debounceTime(500), distinctUntilChanged())
                    .subscribe(value => {
                        this.totalAllocation = this.questionService.calculateTotalAllocation(this.parentArray.value, this.sectionInput.field);
                        this.onChange(this.totalAllocation);
                        this.changeDetector.markForCheck();
                    });
            });

            // check for closed child resposne and recalculate percentage
            if (this.parentArray.controls.length < this.arrayLength) {
                this.totalAllocation = this.questionService.calculateTotalAllocation(this.parentArray.value, this.sectionInput.field);
                this.onChange(this.totalAllocation);
                this.changeDetector.markForCheck();
            }
            this.arrayLength = this.parentArray.controls.length;

        });
    }
}
